import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import LoginPage from "./pages/LoginPage";
import DriverDashboard from "./pages/DriverDashboard";
import DeliveryCapture from "./pages/DeliveryCapture";
import DeliveryDocket from "./pages/DeliveryDocket";
import AdminDashboard from "./pages/AdminDashboard";
import CustomersPage from "./pages/CustomersPage";
import JobsPage from "./pages/JobsPage";
import DriversPage from "./pages/DriversPage";
import UploadPage from "./pages/UploadPage";
import SettingsPage from "./pages/SettingsPage";

import "./App.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#003366]"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/driver"} replace />;
  }
  
  return children;
};

function AppRoutes() {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#003366]"></div>
      </div>
    );
  }
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === "admin" ? "/admin" : "/driver"} replace /> : <LoginPage />} />
      
      {/* Driver Routes */}
      <Route path="/driver" element={<ProtectedRoute allowedRoles={["driver", "admin"]}><DriverDashboard /></ProtectedRoute>} />
      <Route path="/driver/deliver/:jobId" element={<ProtectedRoute allowedRoles={["driver", "admin"]}><DeliveryCapture /></ProtectedRoute>} />
      <Route path="/driver/docket/:proofId" element={<ProtectedRoute allowedRoles={["driver", "admin"]}><DeliveryDocket /></ProtectedRoute>} />
      
      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute allowedRoles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/customers" element={<ProtectedRoute allowedRoles={["admin"]}><CustomersPage /></ProtectedRoute>} />
      <Route path="/admin/jobs" element={<ProtectedRoute allowedRoles={["admin"]}><JobsPage /></ProtectedRoute>} />
      <Route path="/admin/drivers" element={<ProtectedRoute allowedRoles={["admin"]}><DriversPage /></ProtectedRoute>} />
      <Route path="/admin/upload" element={<ProtectedRoute allowedRoles={["admin"]}><UploadPage /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute allowedRoles={["admin"]}><SettingsPage /></ProtectedRoute>} />
      <Route path="/admin/docket/:proofId" element={<ProtectedRoute allowedRoles={["admin"]}><DeliveryDocket /></ProtectedRoute>} />
      
      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
